import type { ReactNode } from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

/**
 * A stated condition — the module's one banner.
 *
 * Named `Notice` rather than Meteoric's `AlertBanner` because `Alert` is the
 * shell-owned primitive it wraps, and two things called Alert in one tree is
 * how a module ends up with its own copy of a shared component.
 *
 * Meteoric had four kinds (info / warn / bad / dark) drawn in four colours. The
 * portal `Alert` has one appearance, so the KIND is carried by the title text
 * the caller writes. That is a real constraint and it is the right one here:
 * "Publishing is not wired up yet" and "The edge request failed" were the same
 * grey box in Meteoric too — only the icon differed, and an icon is not a
 * sentence.
 */
export function Notice({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <Alert>
      <AlertTitle>{title}</AlertTitle>
      {children && <AlertDescription>{children}</AlertDescription>}
    </Alert>
  );
}
